<template>
  <div class="top-players-container">
    <h1><img src="@/assets/Players.svg" /></h1>
    <table class="top-players">
      <thead>
        <tr>
          <th>Rank</th>
          <th>Player</th>
          <th>Region</th>
          <th>Score</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(value, index) in records" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ value.SM_NAME || "XXXX" }}</td>
          <td>{{ value.REGION || "XXXX" }}</td>
          <td>{{ value.score || "XXXX" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TopPlayers',
  props: {
    records: Array
  }
}
</script>

<style lang="scss" scoped>

h1 img {
  max-width: 450px;
}

table {
  border-collapse: collapse;
  font-size: 28px;
  font-weight: bold;
  margin: 0 auto 50px;
  max-width: 1366px;
  text-transform: uppercase;
  width: 100%;
}
th, td {
  color: #fff;
}

thead {
  margin-bottom: 10px;
}

th {
  padding: 25px 0;
}

tbody tr {
  &:first-child {
    background: #f47721;
  }
}

td {
  font-size: 32px;
  padding: 10px 0;
}
</style>

